import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import withTranslateProvider from 'src/hoc/with-translate-provider'
import HeadMetaTags from '~/components/HeadMetaTags'
import RequestDemoContainer from '~/features/request-demo'
import en_request_demo from '../../public/locales/en/request-demo.json'
import jp_request_demo from '../../public/locales/ja/request-demo.json'

const RequestDemoPage: FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <HeadMetaTags
        title={t('meta:request_demo:meta_title')}
        description={t('meta:request_demo:meta_description')}
      />
      <RequestDemoContainer />
    </>
  )
}

export default withTranslateProvider(RequestDemoPage, {
  en: { request_demo: en_request_demo },
  ja: { request_demo: jp_request_demo }
})
